import React, { useCallback } from 'react';
import { FIXED_ITEM_BUTTON } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { MENU_ID_PLANS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { CommonNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/common-nav-menu-button/main.tsx';
import { useCreateNewPlanWizardDrawer } from '@jira/portfolio-3__create-new-plan-wizard-drawer/src/controllers/index.tsx';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import AddIcon from '@atlaskit/icon/core/add';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics';

const createPlan = defineMessage({
	id: 'navigation-apps-sidebar-nav4-plans.plans.common.action-buttons.create-plan-menu-button.create-plan',

	defaultMessage: 'Create plan',
	description: 'Description for the create plan menu item',
});

export const CreatePlanMenuButton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const [, { openDrawer: openCreateNewPlanWizardDrawer }] = useCreateNewPlanWizardDrawer();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const clickHandler = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), {
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_PLANS],
			attributes: {
				level: LEVEL_ONE,
				componentType: FIXED_ITEM_BUTTON,
				itemId: 'createPlan',
			},
		});
		openCreateNewPlanWizardDrawer();
	}, [openCreateNewPlanWizardDrawer, createAnalyticsEvent]);

	return (
		<Tooltip content={formatMessage(createPlan)}>
			<CommonNavMenuButton
				icon={(iconProps) => <AddIcon {...iconProps} size="small" />}
				label={formatMessage(createPlan)}
				onClick={clickHandler}
			/>
		</Tooltip>
	);
};
